const ADMINISTRATOR = 'Administrator';
const CUSTOMER = 'Customer';

const ROLES = {
    ADMINISTRATOR,
    CUSTOMER,   
};

export default ROLES;